import React from 'react';
import { Alert, AlertDescription } from 'components/ui/alert';
import { Icon } from 'components/ui/icon';
import { cn } from 'lib/utils';

interface InfoAlertProps {
  children: React.ReactNode;
  className?: string;
}

const InfoAlert: React.FC<InfoAlertProps> = ({ children, className }) => {
  return (
    <Alert
      variant="info"
      className={cn('flex items-start p-4 max-w-3xl mb-6 mt-3', className)}
    >
      <Icon
        name="info"
        size={20}
        className="mr-2 shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <AlertDescription className="text-sm">{children}</AlertDescription>
    </Alert>
  );
};

export default InfoAlert;
